import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Tag, Tooltip } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";

interface LeadStateCellProps {
    state: boolean;
    status: string | null;
}

export const LeadStateCell = ({ state, status }: LeadStateCellProps) => {
    const { t: tGL } = usePaldockTranslation("tables.general-labels");
    const { t: tGeneral } = usePaldockTranslation("general");

    const translationKey = status ? `conversion_state_status.${status}` : undefined;
    const translated = translationKey ? tGeneral(translationKey) : undefined;
    const description = translated !== translationKey ? translated : undefined;

    const tag = (
        <Tag icon={state ? <CheckCircleOutlined /> : <CloseCircleOutlined />} color={state ? "green" : "red"}>
            {state ? tGL("ok") : tGL("fail")}
        </Tag>
    );

    return description ? (
        <Tooltip title={description} color="black">
            {tag}
        </Tooltip>
    ) : (
        tag
    );
};
